export interface IAddress {
    city?: string | null;
    country?: string | null;
    houseLetter?: string | null;
    houseNumber?: string | null;
    houseNumberSuffix?: string | null;
    state?: string | null;
    street?: string | null;
    zip?: string | null;
}

function join(...args: (string | null | undefined)[]) {
    return args.filter((arg) => arg).join(', ');
}

export function getFormattedAddress(address: IAddress, includeExtendedInfo?: boolean) {
    let formattedAddress = '';
    formattedAddress += address.street || '';
    if (address.street && (address.houseNumber || address.houseLetter || address.houseNumberSuffix)) {
        formattedAddress += ' ';
    }
    formattedAddress += address.houseNumber || '';
    formattedAddress += address.houseLetter || '';
    if (address.houseNumberSuffix && (address.houseNumber || address.houseLetter)) {
        formattedAddress += ' ';
    }
    formattedAddress += address.houseNumberSuffix || '';

    if (includeExtendedInfo) {
        formattedAddress = join(formattedAddress, address.city, address.zip, address.country, address.state);
    }

    return formattedAddress;
}

export function getFormattedZipAndHouseNumber(address: IAddress) {
    let formattedZipAndHouseNumber = address.zip ? address.zip + ' ' : '';

    formattedZipAndHouseNumber += address.houseNumber || '';
    formattedZipAndHouseNumber += address.houseLetter || '';
    if (address.houseNumberSuffix && (address.houseNumber || address.houseLetter)) {
        formattedZipAndHouseNumber += ' ';
    }
    formattedZipAndHouseNumber += address.houseNumberSuffix || '';

    return formattedZipAndHouseNumber;
}
